import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setAuthorization from '../utils/helpers/setAuthorization'
import { API_BASE_URL_AWARI } from '../constants/api'
import { UserModel } from '@models'

const profileAwariRepository = createApi({
	reducerPath: 'profileAwariRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL_AWARI,
	}),
	tagTypes: ['Profile'],
	endpoints: (builder) => ({
		getUserAwari: builder.query<UserModel.ProfileAwari, void>({
			query: () => ({
				url: `/profile`,
				method: 'GET',
			}),
			providesTags: ['Profile'],
		}),
	}),
})

export default profileAwariRepository
